import React from 'react';
import classNames from 'classnames';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const DeviceTransactionFinalReviewScreen = (props) => {
  const {
    deviceId,
    machineId,
    selectedTransactionAmount,
    selectedTransactionType,
    selectedPaymentStatus,
    selectedOriginationPoint,
    selectedTechnicianName,
    selectedCustomerDisplay,
    selectedTeamMemberDisplay,
    selectedNotes,
    selectedOrderCode,
    onBack,
    onNext,
    disableFinalSubmitButton,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Final data for simulating device transactions</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Please reviews the final details to ensure your selections look good!</p>
          <div className={styles.formReviewRowLayout}>
            <p className={styles.formLabel}>Device ID: </p>
            <p>{deviceId}</p>
          </div>
          <div className={styles.formReviewRowLayout}>
            <p className={styles.formLabel}>Machine ID: </p>
            <p>{machineId}</p>
          </div>
          {selectedOriginationPoint && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Transaction Origination Point: </p>
              <p>{selectedOriginationPoint}</p>
            </div>
          )}
          {selectedTransactionType && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Transaction Type: </p>
              <p>{selectedTransactionType}</p>
            </div>
          )}
          {selectedPaymentStatus && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Payment Status: </p>
              <p>{selectedPaymentStatus}</p>
            </div>
          )}
          {selectedTeamMemberDisplay && (
            <div className={styles.formReviewRowLayout}>
            <p className={styles.formLabel}>Team Member: </p>
            <p>{selectedTeamMemberDisplay}</p>
          </div>
          )}
          {selectedTechnicianName && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Technician Name: </p>
              <p>{selectedTechnicianName}</p>
            </div>
          )}
          {selectedCustomerDisplay && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Customer: </p>
              <p>{selectedCustomerDisplay}</p>
            </div>
          )}
          {selectedOrderCode && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Order Code: </p>
              <p>{selectedOrderCode}</p>
            </div>
          )}
          {selectedNotes && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Notes: </p>
              <p>{selectedNotes}</p>
            </div>
          )}
          <div className={styles.formReviewRowLayout}>
            <p className={styles.formLabel}>Transaction Amount: </p>
            <p>${selectedTransactionAmount}</p>
          </div>
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !disableFinalSubmitButton,
          })}
          disabled={!disableFinalSubmitButton}
          onClick={onNext}
        >
          Submit
        </button>
      </footer>
    </>
  );
};

export default DeviceTransactionFinalReviewScreen;
